import { AxiosRequestConfig } from "axios";
import { URL_ENDPOINTS } from "../../constants";
import { axiosInstance as Api } from "../../utils/api-helper";
import { DataType, CommercialOfferResult, SimulationResult } from "./types";

const LoanSimulationService = {
  create: (
    data: DataType,
    config?: AxiosRequestConfig
  ): Promise<CommercialOfferResult> => {
    return Api.post(URL_ENDPOINTS.FINANCIAL, data, config);
  },
  simulation: (loanId: string): Promise<SimulationResult> => {
    return Api.post(URL_ENDPOINTS.LOAN + `/${loanId}/simulate-amortizations`, {
      type: "TOTAL",
    });
  },
};

export default LoanSimulationService;
